export default "__VITE_ASSET__d722ed59__"